// Memory only: design_system brings the flag on every boot, long before a
// player can reach a pack page, and a reload re-fetches it.
let enabled = false;
const listeners = new Set<() => void>();

/** The operator has provably fair on (design_system `provably_fair`). */
export function loadFairnessEnabled(): boolean {
  return enabled;
}

export function saveFairnessEnabled(on: boolean | undefined): void {
  const next = on === true;
  if (next === enabled) return;
  enabled = next;
  for (const cb of listeners) cb();
}

export function subscribeFairnessEnabled(cb: () => void): () => void {
  listeners.add(cb);
  return () => {
    listeners.delete(cb);
  };
}
